import { useState } from "react";

import { SpotlightSearch } from "@components/CasesList/components/SpotlightSearch";
import { PageHeader } from "@components/PageHeader";
import { Button } from "@components/ui/button";

import { useTemplates } from "@hooks/queries/use-templates";

import { CreateTemplateModal } from "./components/CreateTemplateModal";
import { TemplateCard } from "./components/TemplateCard";
import { TemplateCardSkeleton } from "./components/TemplateCardSkeleton";

const ReportTemplatesPage = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const { data: templates = [], isLoading } = useTemplates();

  const filteredTemplates = templates.filter((template) =>
    template.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="space-y-6 px-10 py-8">
      <PageHeader
        title="Report Templates"
        description="Manage and create report templates for your cases."
      />

      <div className="flex items-center gap-2">
        <SpotlightSearch
          placeholder="Search templates here..."
          value={searchQuery}
          onChange={setSearchQuery}
        />
        <Button size="sm" onClick={() => setIsCreateModalOpen(true)}>
          Create New Template
        </Button>
      </div>

      {isLoading ? (
        <div className="space-y-4">
          {Array.from({ length: 3 }).map((_, index) => (
            <TemplateCardSkeleton key={index} />
          ))}
        </div>
      ) : filteredTemplates.length === 0 ? (
        <div className="flex items-center justify-center py-12">
          <div className="text-muted-foreground">No templates found</div>
        </div>
      ) : (
        <div className="space-y-4">
          {filteredTemplates.map((template) => (
            <TemplateCard
              key={template.id}
              template={template}
              allTemplates={templates}
            />
          ))}
        </div>
      )}

      <CreateTemplateModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        templates={templates}
      />
    </div>
  );
};

export default ReportTemplatesPage;
